/**
 * Adzuki.AddressVerification
 */

(function AddressVerification($, Adzuki)
{
	"use strict";

	var AddressVerification = {};

	// do they want to submit the form even though Satori rejected the address?
	AddressVerification.confirmRejected = function confirmRejected(response, form_name)
	{
		var rdata                    = response.data,
		    message                  = rdata.message,
		    fields                   = rdata.fields,
		    $jForm                   = $('form[name="' + form_name + '"]'),
		    force_address_input_name = fields[0].attributes.name,
		    satori_updated_id        = fields[1].attributes.id;


		Adzuki.CustomConfirm({
			close_icon: true,
			body      : message,
			confirm   : function yes() {
				Adzuki.AddressVerification.setForceAddress(force_address_input_name);
				Adzuki.AddressVerification.setSatoriUpdated(satori_updated_id, 0);

				// submit the form
				$jForm.submit();
			}
		});
	};

	// Satori had a suggested alternative address. What does the user want to do with it?
	AddressVerification.confirmWithSuggestion = function confirmWithSuggestion(response, form_name)
	{
		var rdata                    = response.data,
			message                  = rdata.message,
			code                     = rdata.response_code,
			fields                   = rdata.fields,
			$jForm                   = $('form[name="' + form_name + '"]'),
			address2_issue           = this.secondaryAddressIssue(code),
			address_correction       = this.suggestedAddressCorrection(code),
			force_address_input_name = fields[5].attributes.name,
			address2_input_id        = fields[1].attributes.id,
			satori_updated_id        = fields[6].attributes.id;

		if (address2_issue === true) {
			this.highlightAddress2(address2_input_id);
		}

		Adzuki.CustomConfirm({
			close_icon: true,
			body      : message,
			confirm   : function yes() {
				// an address2 issue
				if (address2_issue === true) {
					Adzuki.AddressVerification.setForceAddress(force_address_input_name);
				}

				// Satori suggested an alternative address, and user went with it
				if (address_correction === true) {

					// populate fields with suggested changes
					Adzuki.AddressVerification.suggestionPopulation(fields);

					Adzuki.AddressVerification.setSatoriUpdated(satori_updated_id, 1);
				}

				// submit the form
				$jForm.submit();
			},
			cancel: function no() {
				if (address_correction === true) {
					Adzuki.AddressVerification.setForceAddress(force_address_input_name);
					Adzuki.AddressVerification.setSatoriUpdated(satori_updated_id, 0);
					$jForm.submit();
				}
			}
		});
	};

	/**
	 * If Satori cannot validate the Address 2 field or it's missing a value, we will want to highlight the field along with the confirm dialog message
	 * @param  string address2_input_id   id attribute of "address 2" input
	 */
	AddressVerification.highlightAddress2 = function highlightAddress2(address2_input_id)
	{
		$('#' + address2_input_id).addClass('form-error');
	};

	/**
	 * Determines if Satori response code indicates an issue with the "address 2" field
	 * @param  int     code  code returned by Satori
	 * @return boolean       true if the error code means issue with "address 2"
	 */
	AddressVerification.secondaryAddressIssue = function secondaryAddressIssue(code)
	{
		if ( (code >= 91) && (code <= 99) ) {
			return true;
		}
		return false;
	};

	/**
	 * Find the 'force_address' field and check it.
	 * @param string name of the force_address input. Because it's a checkbox, the id attribute does not seem to be set for some reason
	 */
	AddressVerification.setForceAddress = function setForceAddress(input_name)
	{
		$('input[type=checkbox][name="' + input_name + '"]').attr('checked', true);
	};

	AddressVerification.setSatoriUpdated = function setSatoriUpdated(input_id, value)
	{
		$('#' + input_id).val(value);
	};

	/**
	 * Determines if Satori response code indicates that Satori has provided a suggested alternative address
	 * @param  int     code  code returned by Satori
	 * @return boolean       true if alternative address provided by Satori
	 */
	AddressVerification.suggestedAddressCorrection = function suggestedAddressCorrection(code)
	{
		if (code < 91) {
			return true;
		}
		return false;
	};

	AddressVerification.suggestionPopulation = function suggestionPopulation(fields)
	{
		// populate fields with suggested changes
		jQuery.each(fields, function feach(index, input) {
			if (input.value !== input.suggested_alternative) {
				$('#' + input.attributes.id).val(input.suggested_alternative);
			}
		});
	};

	Adzuki.AddressVerification = AddressVerification;

}(jQuery, window.Adzuki || {}));
